import { useState } from 'react'

import { SequenceMenuItem } from '@sequencehq/core-components'

import { usePermissions } from 'lib/rbac'

import { RecordPaymentDrawer } from './RecordPaymentDrawer'

/**
 * Kebab item opening the record-payment drawer for an issued invoice. The caller
 * (KebabMenu) gates on manual-payment eligibility and invoice status.
 */
export const MenuItemRecordPayment = ({ invoiceId }: { invoiceId: string }) => {
  const { can } = usePermissions()
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)

  if (!can('org.invoice:update')) {
    return null
  }

  return (
    <>
      <SequenceMenuItem
        uuid="record-payment"
        label="Apply payment"
        onClick={() => setIsDrawerOpen(true)}
        data-testid="invoices.recordPayment.menuItem"
      />
      {isDrawerOpen && (
        <RecordPaymentDrawer
          invoiceId={invoiceId}
          onClose={() => setIsDrawerOpen(false)}
        />
      )}
    </>
  )
}
